import React from 'react';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Portfolio from './Portfolio';
import ServiceRequest from './ServiceRequest';

const Home = ({ onFormSubmit }) => {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Portfolio />
      <ServiceRequest onSubmit={onFormSubmit} />
    </>
  );
};

export default Home;
